module.exports = __webpack_public_path__ + "img/SpatialTrackingOutlined.fec76672.svg";